import { useCallback, useMemo } from "react";
import { useWatch } from "react-hook-form";

import {
  getOfferedHomeStationIds,
  isStationOptionShown,
  type IDropdownItemExt,
  type IDropdownItemStations,
  type ISelectListItemExt,
} from "@ryde/shared";

export const useBookingHomeStationDropdown = ({
  name,
  homeStations,
  addedStationIds,
}: {
  name: string;
  homeStations: IDropdownItemStations[];
  addedStationIds: number[];
}) => {
  const selectedStationId = useWatch({ name });

  const offeredStationIds = useMemo(
    () => getOfferedHomeStationIds({ homeStations, addedStationIds }),
    [homeStations, addedStationIds],
  );

  const isHomeStationOptionShown = useCallback(
    (item: IDropdownItemExt | ISelectListItemExt): boolean =>
      isStationOptionShown({
        stationId: item.value,
        listedStationIds: offeredStationIds,
        selectedStationId,
      }),
    [offeredStationIds, selectedStationId],
  );

  // The other home field loaded its items before the station existed; a new key reloads them.
  const dropdownItemsReloadKey = addedStationIds.join(",");

  return { isHomeStationOptionShown, dropdownItemsReloadKey };
};
